import React, { FC, useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { PageNotFound } from '../404';
import { ChunkLoader } from './ChunkLoader';
import { isChunkLoadFailure, reloadForChunkLoadFailure } from '../../tools/chunkLoadRecovery';

export const RouteErrorBoundary: FC<React.PropsWithChildren<unknown>> = () => {
    const error = useRouteError();
    const isChunkFailure = isChunkLoadFailure(error);

    useEffect(() => {
        if (isChunkFailure) {
            reloadForChunkLoadFailure();
            return;
        }
        console.error(error);
    }, [error, isChunkFailure]);

    if (isChunkFailure) {
        return <ChunkLoader />;
    }

    return <PageNotFound />;
};
